import React from "react"
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';

import FavoriteIcon from '@material-ui/icons/Favorite';
import CodeIcon from '@material-ui/icons/Code';
import PersonIcon from '@material-ui/icons/Person';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import EmojiEmotionsTwoToneIcon from '@material-ui/icons/EmojiEmotionsTwoTone';


 const About = () => {
  return (
     <>

          <div>
            <List >

                <ListItem >
                  <ListItemAvatar>
                     <Avatar color="secondary">
                       <FavoriteIcon />
                     </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="I love taking constructive criticism and accepting feedback."/>
                </ListItem>

                <ListItem >
                  <ListItemAvatar>
                     <Avatar>
                       <LoyaltyIcon />
                     </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="I'm intrested in Digital sales and Marketing especially capturing value from big data and advanced analytics."/>
                </ListItem>

                <ListItem >
                  <ListItemAvatar>
                     <Avatar>
                       <EmojiEmotionsTwoToneIcon />
                     </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="I’m self driven currently working on Full-Stack Web Development"/>
                </ListItem>

                <ListItem >
                  <ListItemAvatar>
                     <Avatar>
                       <DirectionsWalkIcon />
                     </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Going the extra mile to make a difference, having the drive to lead and succeed."/>
                </ListItem>


                <ListItem >
                  <ListItemAvatar>
                     <Avatar>
                       <PersonIcon />
                     </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Pronouns: He/His/Single."/>
                </ListItem>

                <ListItem >
                  <ListItemAvatar>
                     <Avatar>
                       <CodeIcon />
                     </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Fun fact: I can code 24/7." secondary="Javascript"/>
                </ListItem>
            </List>
</div>












     </>
  )
 }

export default About;